import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import InfoDisplay from '../InfoDisplay';
import { CategoriesStack } from '../styles';
import Typography from '@mui/material/Typography';
import { NoDataContainer } from '../../styles';

interface ERPArrayType {
  splitter: { label: string; value: string | number }[];
  connection: { label: string; value: string | number }[];
  routing: { label: string; value: string | number }[];
}

function ERP({
  modeView,
  customerData,
}: {
  modeView: string;
  customerData: CustomerDataType;
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  // Prepare iterable data for ERP sections
  const erpData: ERPArrayType = {
    splitter: [
      {
        label: t('equipment.customer.splitter.splitterDescription'),
        value: customerData?.splitterDescription ?? '',
      },
      {
        label: t('equipment.customer.splitter.splitterNumber'),
        value: customerData?.splitterNumber ?? '',
      },
    ],
    connection: [
      {
        label: t('equipment.customer.connection.nameConnection'),
        value: customerData?.nameConnection ?? '',
      },
      {
        label: t('equipment.customer.connection.ipv4Connection'),
        value: customerData?.ipv4Connection ?? '',
      },
      {
        label: t('equipment.customer.connection.ponPort'),
        value: customerData?.ponPort ?? '',
      },
      {
        label: t('equipment.customer.connection.VLAN'),
        value: customerData?.vlan ?? '',
      },
    ],
    routing: [
      {
        label: t('equipment.customer.routing.nameRouting'),
        value: customerData?.nameRouting ?? '',
      },
      {
        label: t('equipment.customer.routing.ipv4Routing'),
        value: customerData?.ipv4Routing ?? '',
      },
    ],
  };

  return (
    <Stack width="100%" gap={2}>
      {customerData ? (
        <CategoriesStack modeView={modeView}>
          {/** Routing Equipment Info */}
          <InfoDisplay
            title={t('equipment.customer.routing.title')}
            info={erpData.routing}
            modeView={modeView}
            icon="router"
            color={theme.palette.tertiary.main}
          />

          {/** Connection Equipment Info */}
          <InfoDisplay
            title={t('equipment.customer.connection.title')}
            info={erpData.connection}
            modeView={modeView}
            icon="hard-drive"
            color={theme.palette.secondary.main}
          />

          {/** Splitter Info */}
          <InfoDisplay
            title={t('equipment.customer.splitter.title')}
            info={erpData.splitter}
            modeView={modeView}
            icon="utility-pole"
            color={theme.palette.tertiary.main}
          />
        </CategoriesStack>
      ) : (
        <NoDataContainer>
          <Typography variant="h6" color={theme.palette.grey['01']}>
            {t('equipment.customer.noConnectionData')}
          </Typography>
        </NoDataContainer>
      )}
    </Stack>
  );
}

export default ERP;
